import React, {useEffect, useState} from 'react';
import {
  ButtonCategory,
  ButtonCategoryText,
  ButtonsCategory,
  Container,
  Content,
  ContentTitles,
  FiltersContainer,
  ItemContainer,
  ItemDescription,
  ItemName,
} from './styles';
import analytics from '@react-native-firebase/analytics';
import {Header} from '../../components/Interface/Headers/Header';
import {Titles} from '../../components/Interface/Typographies/Titles';
import {ListRenderItem} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {FlatList} from 'react-native-gesture-handler';
import {api} from '../../services/api';
import {Loading} from '../../components/Interface/Loadings/Loading';
import {v4 as uuid} from 'uuid';

export interface IUser {
  id: string;
  cidade: string;
  postos: {
    nome: string;
    endereco: string;
  }[];
}
export interface ICategory {
  nome: string;
  codigo: string;
}

const Item = ({data}: {data: IUser}) =>
  data.postos.length > 0 ? (
    <ItemContainer>
      <ItemName>{data.cidade}</ItemName>
      {data.postos.map(posto => (
        <ItemDescription key={uuid()}>{posto.nome}</ItemDescription>
      ))}
    </ItemContainer>
  ) : (
    <></>
  );

export function ListLocations() {
  const [categories, setCategories] = useState<ICategory[]>([] as ICategory[]);
  const [selectedCategories, setSelectedCategories] = useState('O');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const renderItem: ListRenderItem<IUser> = ({item}) => <Item data={item} />;

  const handleCategoryPress = (category: string) => {
    setSelectedCategories(category);
    handleCategory(category);
  };

  async function handleCategory(category: string) {
    setLoading(true);
    try {
      const response = await api.get('/listaPostosTipoProduto', {
        params: {
          tipo_produto: category,
        },
      });
      if (response.data) {
        setData(response.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    async function fetchLocation() {
      try {
        const response = await api.get('/listaPostosTipoProduto', {
          params: {
            tipo_produto: selectedCategories,
          },
        });
        if (response.data) {
          setData(response.data);
          fetchCategories();
        }
      } catch (err) {
        console.log(err);
      }
    }

    async function fetchCategories() {
      try {
        const response = await api.post('/tipoProduto');
        if (response.data) {
          const {data} = response;
          const filterLocationsCateogories = data.filter(
            (item: any) => item.codigo !== 'M' && item.codigo !== 'B',
          );
          setCategories(filterLocationsCateogories);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }

    analytics().logEvent('tela_lista_locais_estatico');

    fetchLocation();
  }, []);

  return (
    <Container>
      {loading && <Loading />}
      <Header icon="chevron-left" />
      <ContentTitles>
        <Titles
          title="Lista de locais"
          subtitle="Aqui está uma lista com todos os nossos parceiros"
        />
      </ContentTitles>
      <FiltersContainer>
        <ButtonsCategory>
          {categories.map(category => (
            <ButtonCategory
              activeOpacity={1}
              key={uuid()}
              selected={selectedCategories === category.codigo}
              onPress={() => handleCategoryPress(category.codigo)}>
              <ButtonCategoryText
                selected={selectedCategories === category.codigo}>
                {category.nome}
              </ButtonCategoryText>
            </ButtonCategory>
          ))}
        </ButtonsCategory>
      </FiltersContainer>

      <Content>
        {data.length > 0 && (
          <FlatList
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              paddingBottom: RFValue(20),
            }}
            data={data}
            renderItem={renderItem}
            keyExtractor={() => uuid()}
          />
        )}
      </Content>
    </Container>
  );
}
